// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format2 } from '../../constants';

/** Kazakhstan */
const KZ: PhoneNumberData = [7, 'KZ', 10, format2, /^(?:7)/];

export default KZ;
